import { connect } from 'react-redux';
import { RootState } from '../types';

import { ListingHighlights } from '../components/ListingHighlights';

import {
  getCancellationPolicy,
  getCurrentOccupancy,
  getFacilities,
  getFreePlaces,
  getKind,
  getType,
  getIsImperialSystem,
} from '../selectors';

const ListingHighlightsContainer = connect((state: RootState) => ({
  cancellationPolicy: getCancellationPolicy(state),
  currentOccupancy: getCurrentOccupancy(state),
  facilities: getFacilities(state),
  freePlaces: getFreePlaces(state),
  kind: getKind(state),
  type: getType(state),
  isImperialSystem: getIsImperialSystem(state),
}))(ListingHighlights);
export { ListingHighlightsContainer };
